<template>
  <div>
    <el-form
      ref="searchForm"
      :model="searchInfo"
      :inline="true"
      :label-position="position"
    >
      <el-form-item>
        <el-input
          v-model="searchInfo.modelName"
          placeholder="型号查询"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.sn"
          placeholder="小码查询"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.batch"
          placeholder="批次"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-date-picker
          v-model="searchInfo.createTimePicker"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          plain
          size="medium"
          @click="handlerSearch"
          icon="fa fa-search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-row>
      <div class="avue-crud__menu">
        <div class="avue-crud__left">
          <button
            class="el-button filter-item el-button--info el-button--mini"
            style="padding:0 0 0 0px"
          >
            <el-upload
              ref="upload"
              action
              :http-request="handleUploadFile"
              :on-exceed="handleUploadExceed"
              :limit="1"
              :show-file-list="false"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            >
              <button
                class="el-button filter-item el-button--info el-button--mini"
              >
                <i class="fa fa-upload"></i>
                <span>导入</span>
              </button>
            </el-upload>
          </button>
          <button
            @click="handleExport"
            type="button"
            class="el-button filter-item el-button--warning el-button--mini"
          >
            <i class="fa fa-download"></i>
            <span>导出</span>
          </button>
        </div>
        <div class="avue-crud__right">
          <button
            type="button"
            class="el-button el-tooltip el-button--default el-button--small is-circle"
            aria-describedby="el-tooltip-2497"
            tabindex="0"
            title="刷新"
            @click="handlerRefresh"
          >
            <i class="el-icon-refresh"></i>
          </button>
        </div>
      </div>
      <el-col :xs="10">
        <el-table
          style="width: 100%;"
          ref="postListRef"
          :data="tableData"
          border
          :fit="true"
          :header-cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            prop="modelName"
            label="型号名称"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="sn"
            label="SN码"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="price"
            label="价值"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="batch"
            label="批次"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
          <el-table-column
            prop="memo"
            label="备注"
            sortable
            resizable
            :show-overflow-tooltip="true"
            align="center"
          />
        </el-table>
        <el-pagination
          align="left"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchInfo.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="Number(searchInfo.total)"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  queryScrapProfitPage,
  scrapProfitUpload,
  scrapProfitExport
} from "../../api/api";
import { hideLoading, showLoading } from "../../components/loading/loading";
export default {
  data() {
    return {
      //检索
      searchInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0
      },
      tableData: [],
      position: "left"
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      let _self = this;
      let params = _self.getQueryParams();
      showLoading();
      queryScrapProfitPage(params)
        .then(res => {
          if (res.data.status == 100) {
            _self.tableData = res.data.results.list;
            _self.searchInfo.total = res.data.results.total;
          }
        })
        .finally(() => {
          hideLoading();
        });
    },
    getQueryParams() {
      const sqp = {};
      const param = Object.assign(sqp, this.searchInfo);
      if (
        this.searchInfo.createTimePicker &&
        this.searchInfo.createTimePicker.length > 0
      ) {
        param.beginCreateTime = param.createTimePicker[0];
        param.endCreateTime = param.createTimePicker[1];
        param.createTimePicker = undefined;
      }
      param.startRow=param.pageNum;
      param.pageNum=undefined;
      return this.filterObj(param);
    },
    handlerSearch() {
      this.searchInfo.pageNum = 1;
      this.onLoad();
    },
    handleSizeChange(pageSize) {
      this.searchInfo.pageSize = pageSize;
      this.onLoad();
    },
    handleCurrentChange(pageNum) {
      this.searchInfo.pageNum = pageNum;
      this.onLoad();
    },
    handlerRefresh() {
      this.searchInfo.pageNum = 1;
      this.onLoad();
    },
    /**
      超出最大上传文件数量时的处理方法
     */
    handleUploadExceed() {
      this.$message({
        type: "warning",
        message: "超出最大上传文件数量的限制！"
      });
      return;
    },
    /**
     * 自定义上传
     */
    handleUploadFile(params) {
      let _self = this;
      let data = new FormData();
      data.append("file", params.file);
      showLoading();
      scrapProfitUpload(data)
        .then(res => {
          if (res.data.status == 100) {
            _self.$message({
              message: res.data.message,
              type: "success"
            });
            _self.onLoad();
          } else {
            _self.$message({
              message: res.data.message,
              type: "warning"
            });
          }
        })
        .finally(() => {
          hideLoading();
        });
      // _self.scrapProfitUpload({ url: url, data: data }).then(result => {
      //   _self.$message({
      //     message: result,
      //     type: "success"
      //   });
      //   _self.getPage();
      // });
      _self.$refs.upload.clearFiles();
    },
    filterObj(obj) {
      if (!(typeof obj == "object")) {
        return;
      }

      for (const key in obj) {
        if (
          //eslint-disable-next-line
          obj.hasOwnProperty(key) &&
          (obj[key] == null || obj[key] == undefined || obj[key] === "")
        ) {
          delete obj[key];
        }
      }
      return obj;
    },
    /**
     * 导出
     */
    handleExport() {
      let _self = this;
      // let params = JSON.parse(JSON.stringify(_self.searchInfo));
      // bootAdminExport("post", url, params);
      scrapProfitExport(this.getQueryParams()).then(res => {
        let fileName = res.headers["content-disposition"]
          .split(";")[1]
          .trim()
          .split("filename=")[1]
          .split('"')[1];
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.avue-crud__menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
  width: 100%;
  min-height: 40px;
  height: auto;
  overflow: hidden;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// scrapProfitList.vue?4821421d